<template>
  <div class="company-details-body-text">
    <b-container v-if="fundMapCompanyLoading">
      <h1>Betöltés folyamatban...</h1>
    </b-container>

    <b-container v-else-if="!companyTerminated">
      <div>
        <h1 class="text-left mt-2">
          {{ companyDisplayName }}
        </h1>

        <b-row class="mb-5 mt-4 align-items-center">
          <b-col xs="12" sm="5" md="5" xl="4">
            <div class="text-left">
              Ellenőrizze vállalkozása adatait, majd kattintson a tovább gombra a lehetőségekért!
            </div>
          </b-col>
          <b-col xs="12" sm="7" md="7" xl="8">
            <button type="button" name="button" class="btn btn-primary float-right" @click="nextPage">
              Tovább
            </button>
          </b-col>
        </b-row>

        <b-row>
          <company-details-table :selectedCompany="fundMapCompany"></company-details-table>
        </b-row>

        <company-details-chart :selectedCompany="fundMapCompany"></company-details-chart>

        <b-row>
          <b-col xs="12" sm="5" md="5" xl="4">
            <div class="mt-5 text-left">
              Ellenőrizze vállalkozása adatait, majd kattintson a tovább gombra a lehetőségekért!
            </div>
          </b-col>
          <b-col xs="12" sm="7" md="7" xl="8">
            <button type="button" name="button" class="btn btn-primary mt-5 mb-5 float-right" @click="nextPage">
              Tovább
            </button>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-container v-else>
      <b-row>
        <b-col class="col-12 col-lg-6 text-left">
          <h1 class="mb-4">
            Nem tudunk lehetőséget felkínálni
          </h1>
          <h2 class="mb-5">
            A cége kényszertörlési-, felszámolási-, vagy végelszámolási eljárás alatt van, így sajnos nem tudunk
            lehetőségeket felkínálni.
          </h2>
          <b-button variant="primary" class="mb-4" @click="goToHome">Vissza a főoldalra</b-button>
        </b-col>
        <b-col class="col-6 d-none d-lg-flex">
          <termination-svg class="img-fluid"></termination-svg>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TerminationSvg from '@/components/svg/Termination.vue'
import CompanyDetailsTable from '../../components/CompanyDetailsTable.vue'
import CompanyDetailsChart from '../../components/CompanyDetailsChart.vue'

export default {
  components: {
    TerminationSvg,
    CompanyDetailsTable,
    CompanyDetailsChart
  },
  data() {
    return {
      userAssignedCompany: null,
      companyConnectedToUser: false
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'fundMapCompany', 'fundMapCompanyLoading']),
    companyTerminated() {
      const isUnderTermination =
        !!this.fundMapCompany && !!this.fundMapCompany.termination && !!this.fundMapCompany.termination.length
      const isUnderSuccessorLessTermination =
        !!this.fundMapCompany &&
        !!this.fundMapCompany.successorless_termination &&
        !!this.fundMapCompany.successorless_termination.length

      return isUnderTermination || isUnderSuccessorLessTermination
    },
    companyDisplayName() {
      if (
        this.fundMapCompany &&
        this.fundMapCompany.short_name &&
        this.fundMapCompany.short_name.length &&
        this.fundMapCompany.short_name[0] &&
        this.fundMapCompany.short_name[0].name
      ) {
        return this.fundMapCompany.short_name[0].name
      }

      if (
        this.fundMapCompany &&
        this.fundMapCompany.long_name &&
        this.fundMapCompany.long_name.length &&
        this.fundMapCompany.long_name[0] &&
        this.fundMapCompany.long_name[0].name
      ) {
        return this.fundMapCompany.long_name[0].name
      }

      if (this.fundMapCompany && this.fundMapCompany.name) {
        return this.fundMapCompany.name
      }

      return 'Vállalkozás adatai'
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    },
    nextPage() {
      const companyId =
        this.fundMapCompany?.flaggerId ||
        this.fundMapCompany?.imaginaryCompany?.companyId ||
        this.fundMapCompany?.companyId ||
        this.fundMapCompany?.id

      console.log('fundMapCompany továbbítás előtt:', this.fundMapCompany)
      console.log('továbbított companyId:', companyId)

      if (!companyId) {
        console.error('Nincs továbbadható companyId:', this.fundMapCompany)
        return
      }

      this.$router.push({
        path: '/fund-map/search',
        query: { companyId }
      })
    }
  },
  async mounted() {
    if (!this.fundMapCompany) {
      if (this.$route.query.companyId == null) {
        if (this.isAuthenticated) this.$router.push('/home')
        else this.$router.push('/')
        return
      }

      this.$gtag.event('company_details', {
        event_category: 'user_interaction',
        companyId: this.$route.query.companyId
      })

      const getCompanyQueryParams = { value: this.$route.query.companyId }
      await this.$store.dispatch('getFundMapCompanyAction', getCompanyQueryParams)
    }
  }
}
</script>

<style scoped>
.company-details-body-text {
  color: var(--color-gray-04) !important;
}

button {
  width: 200px;
  height: 48px;
  font-weight: bold;
}

@media (max-width: 575px) {
  .btn-primary {
    width: 100%;
    margin-top: 30px !important;
    margin-bottom: 15px !important;
  }
}
</style>
